import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLang } from '../../i18n';
import styles from './userFeedbackBox.module.css';
import sharedStyles from '../../styles/shared';
import { addErrorMessageAction, submitUserFeedback } from '../../actions';
import { isUserLoggedIn } from '../../util';
import { currentUserType } from '../../constants/types';

const SUCCESS_MESSAGE_CLOSE_TIMEOUT = 5000;

class UserFeedbackBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: 'closed',
      message: ''
    };

    this.openForm = this.openForm.bind(this);
    this.closeForm = this.closeForm.bind(this);
    this.updateMessage = this.updateMessage.bind(this);
    this.sendFeedback = this.sendFeedback.bind(this);
  }

  openForm() {
    this.setState({ status: 'form' });
  }

  closeForm() {
    this.setState({ status: 'closed', message: '' });
  }

  updateMessage(event) {
    const message = event.target.value;
    this.setState({ message });
  }

  sendFeedback() {
    if (this.state.message === '') {
      return;
    }

    this.props.submitFeedback(this.state.message)
      .then(this.setState({ status: 'success', message: '' }))
      .catch((err) => this.props.dispatchAddErrorMessage(err));

    setTimeout(() => this.setState({ status: 'closed' }), SUCCESS_MESSAGE_CLOSE_TIMEOUT);
  }

  renderClosed() {
    return (
      <div className={styles.closed}>
        <button type="button" className="button is-active" onClick={this.openForm} data-cy="user-feedback-open-button">
          <span className="icon-2x icon--chat" />
          <span className={`${sharedStyles.hiddenMobile} ${styles.label}`}>
            {this.props.translate('feedbackBox.feedback')}
          </span>
        </button>
      </div>
    );
  }

  renderForm() {
    return (
      <div className={styles.form}>
        <textarea
          autoFocus // eslint-disable-line jsx-a11y/no-autofocus
          onChange={this.updateMessage}
          maxLength={2000}
          placeholder={this.props.translate('feedbackBox.placeholder')}
          rows={8}
          data-cy="user-feedback-textarea"
          value={this.state.message}
        />
        <div className={styles.buttons}>
          <button type="submit" className="button is-active" onClick={this.sendFeedback} data-cy="user-feedback-submit-button">
            {this.props.translate('feedbackBox.submit')}
          </button>
          <button className="button is-active" type="button" onClick={this.closeForm}>
            <span className="icon--remove" />
          </button>
        </div>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div className={styles.success} data-cy="user-feedback-success">
        <span className="icon-2x icon--done" />
        <div><p>{this.props.translate('feedbackBox.thanks')}</p></div>
      </div>
    );
  }

  render() {
    const { user } = this.props;
    return isUserLoggedIn(user)
      && !user.permissions?.length // Only show to roleless users (students)
      && (
      <div className={styles.container} data-cy="user-feedback-box">
        {this.state.status === 'closed' && this.renderClosed()}
        {this.state.status === 'form' && this.renderForm()}
        {this.state.status === 'success' && this.renderSuccess()}
      </div>
      );
  }
}

const mapStateToProps = ({ user }) => ({
  user: user.currentUser
});

const mapDispatchToProps = (dispatch) => ({
  submitFeedback: (message) => dispatch(submitUserFeedback(message)),
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err))
});

const { func } = PropTypes;
UserFeedbackBox.propTypes = {
  translate: func.isRequired,
  submitFeedback: func.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  user: currentUserType.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(withLang(UserFeedbackBox));
